import React from "react";
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';

const TermsCondition = (props) => {
  const { content, handleClose, isClose } = props;

  return (
    <div className="models-box">
      {isClose && <span className="close-icon" onClick={handleClose}>x</span>}
      {content}
    </div>
  );
};

TermsCondition.propTypes = {
  handleClose: PropTypes.func,
  content: PropTypes.node,
  isClose: PropTypes.bool,
};

export default TermsCondition;